import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import ArticlePreview from '../articlePreview';
import createArticleProps from '../../../utils/recentPublications/createArticleProps';
import createArticleEvents from '../../../utils/trackers/createArticleEvents';

const getLaunchProps = (state, { panel: { launchProps } }) => launchProps;
const getData = ({ authors: { data } }) => data;

export const mapStateToProps = createSelector([getLaunchProps, getData], (launchProps, data) => {
  const { authorIndex, publicationIndex } = launchProps;
  const recentPublications = data[authorIndex];
  const recentPublication = recentPublications.data.scopusDocuments[publicationIndex];
  const articlePreviewProps = createArticleProps(recentPublication);
  const {
    contentType,
    documentType,
    documentSubtype,
    pii,
    doi,
  } = articlePreviewProps;
  const eventData = createArticleEvents('article-preview-author',
    {
      contentType,
      documentType,
      documentSubtype,
    },
    { pii, doi });

  return {
    ...articlePreviewProps,
    eventData,
  };
});

export default connect(mapStateToProps)(ArticlePreview);
